import React from 'react';
import Footer from 'library/sections/footer';

export default class PathwaysFooter extends React.Component {
  render() {
    return (
      <Footer>
        <span>
          Data by: <a style={{textDecoration: 'none', color: 'inherit'}} href="http://burning-glass.com/" target="_blank"><img src="/images/burning-glass.png" /> Burning Glass Technologies</a>
        </span>
      </Footer>
    )
  }
}
